import { Component, HostBinding, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Data, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, filter, map, takeUntil } from 'rxjs/operators';
import { CalsoftMediaWatcherService } from 'src/app/global/services/media-watcher';
import { CalsoftNavigationItem, CalsoftNavigationService } from 'src/app/global/components/navigation';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { cloneDeep } from 'lodash-es';
import { defaultNavigation } from 'src/app/data/mock/common/navigation/data';
import { GeminichatComponent } from 'src/app/geminichat/geminichat.component';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { Constant } from 'src/app/constant/constant';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';

@Component({
    selector: 'classy-layout',
    templateUrl: './classy.component.html',
    styleUrls: ['./classy.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

    url = '';
    opened: boolean = false;
    data: any;
    isScreenSmall: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;
    crmSettingsData: any;

    /**
     * Constructor
     *
     * @param {ActivatedRoute} _activatedRoute
     * @param {CalsoftMediaWatcherService} _calsoftMediaWatcherService
     * @param {CalsoftNavigationService} _calsoftNavigationService
     * @param {Router} _router
     */
    constructor(
        private ecryptService: EcryptServiceService,
        private dialog: MatDialog,
        private calsoftNavigationService: CalsoftNavigationService,
        public crmsetting: CrmsettingsService,
        private _activatedRoute: ActivatedRoute,
        private _calsoftMediaWatcherService: CalsoftMediaWatcherService,
        private _calsoftNavigationService: CalsoftNavigationService,
        private _router: Router
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.url = this._router.url || '';
            this._router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this._router.url || ''; });
    
    this.url = this._router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this._router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.url = this._router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
  }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */


    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param key
     */
    toggleNavigation(key): void {
        // Get the navigation
        const navigation = this._calsoftNavigationService.getComponent(key);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }


    @HostBinding('class.fixed-header')
    fixedHeader: boolean;

    @HostBinding('class.fixed-footer')
    fixedFooter: boolean;

    // Private

    private _matAutocomplete: any;
    appearance: string;
    chatAiType: any = 0;

    /**
     * Constructor
     *
     * @param {ActivatedRoute} _activatedRoute
     * @param {CalsoftMediaWatcherService} _calsoftMediaWatcherService
     * @param {CalsoftNavigationService} _calsoftNavigationService
     * @param {Router} _router
     */


    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    private readonly _defaultNavigation: CalsoftNavigationItem[] = defaultNavigation;

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    @Input() debounce: number = 300;

    @Input() minLength: number = 2;
    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the resolved route data
        this._activatedRoute.data.subscribe((data: Data) => {

            console.log(this.data);

            this.data = data.initialData;
        });

        // Subscribe to media changes
        this._calsoftMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {

                // Check if the breakpoint is 'lt-md'
                this.isScreenSmall = matchingAliases.includes('lt-md');
            });
        let aiEnabled: any;
        let aiType: any;
        const encrypted = localStorage.getItem('crmSettingsData');
        if (encrypted) {
            try {
                const decrypted = this.ecryptService.decryptionAES(encrypted);
                this.crmSettingsData = JSON.parse(decrypted);
                console.log("CRM Settings Data:", this.crmSettingsData);

                aiEnabled = this.crmSettingsData.aiEnabled;
                aiType = this.crmSettingsData.aiType;
            } catch (err) {
                console.error("Error decrypting crmSettingsData", err);
            }
        }




        if (aiEnabled != undefined) {
            this.chatAiEnable = aiEnabled;

        }

        if (aiEnabled != undefined) {
            this.chatAiType = aiType;

        }





        // Subscribe to the resolved route data
        this._activatedRoute.data.subscribe((data: Data) => {
            this.data = data.initialData;

        });

        // Subscribe to media changes
        this._calsoftMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {

                // Check if the breakpoint is 'lt-md'
                this.isScreenSmall = matchingAliases.includes('lt-md');
            });




        this.searchControl.valueChanges
            .pipe(
                debounceTime(this.debounce),
                takeUntil(this._unsubscribeAll),
                map((value) => {


                    // Set the resultSets to null if there is no value or
                    // the length of the value is smaller than the minLength
                    // so the autocomplete panel can be closed
                    if (!value || value.length < this.minLength) {
                        this.resultSets = null;
                    }

                    // Continue
                    return value;
                }),
                // Filter out undefined/null/false statements and also
                // filter out the values that are smaller than minLength
                filter(value => value && value['length'] >= this.minLength)
            )
            .subscribe((value) => {

                this.resultSets = []
                if (value === '') {
                    return this.resultSets = [];
                }
                // Filter the navigation

                console.log(JSON.parse(this.data.navigation.compact[0][0].search));

                const flatNavigation = JSON.parse(this.data.navigation.compact[0][0].search);
                const clean = (s: string) => s ? s.toLowerCase().replace(/[\s\/\-_]+/g, '') : '';
                const valLower = value.toLowerCase();
                const valClean = clean(value);

                const pagesResults = cloneDeep(flatNavigation)
                    .filter(page => {
                        if (!page.link) return false;

                        const titleMatch = page.title && (page.title.toLowerCase().includes(valLower) || clean(page.title).includes(valClean));
                        const defaultNameMatch = page.defaultName && (page.defaultName.toLowerCase().includes(valLower) || clean(page.defaultName).includes(valClean));
                        const linkMatch = page.link && (page.link.toLowerCase().includes(valLower) || clean(page.link).includes(valClean));
                        const nameMatch = page.name && (page.name.toLowerCase().includes(valLower) || clean(page.name).includes(valClean));

                        return titleMatch || defaultNameMatch || linkMatch || nameMatch;
                    });

                if (pagesResults.length > 0) {
                    this.resultSets.push({
                        id: 'pages',
                        label: 'Pages',
                        results: pagesResults
                    });


                } else {
                    this.resultSets = []
                }

            });
    }



    chatAiEnable: any = 0;


    /**
  * On destroy
  */

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param key
     */



    // search 


    searchControl: UntypedFormControl = new UntypedFormControl();
    resultSets: any = []
    resultSets1: any[] = [{
        "id": "pages",
        "label": "Pages",
        "results": [{
            "id": "apps.contacts",
            "title": "Contacts",
            "type": "basic",
            "icon": "heroicons_outline:user-group",
            "link": "/apps/contacts",
            "value": "Contacts"
        },
        {
            "id": "user-interface.confirmation-dialog",
            "title": "Confirmation Dialog",
            "type": "basic",
            "icon": "heroicons_outline:question-mark-circle",
            "link": "/ui/confirmation-dialog",
            "value": "Confirmation Dialog"
        }
        ]
    }];

    open(): void {
        // Return if it's already opened
        if (this.opened) {
            return;
        }

        // Open the search
        this.opened = true;
    }

    close(): void {
        // Return if it's already closed
        if (!this.opened) {
            return;
        }

        // Clear the search input
        this.searchControl.setValue('');

        // Close the search
        this.opened = false;
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }


    onKeydown(event: KeyboardEvent): void {
        // Escape
        if (event.code === 'Escape') {
            // If the appearance is 'bar' and the mat-autocomplete is not open, close the search
            if (this.appearance === 'bar' && !this._matAutocomplete.isOpen) {
                this.close();
            }
        }
    }

    getToRoute(link: any) {
        if (!link) return;
        this.close();
        const targetUrl = link.startsWith('/') ? link : '/' + link;
        this._router.navigateByUrl(targetUrl);
    }



    openChatDialog() {
        const dialogRef = this.dialog.open(GeminichatComponent, {
            width: '100vw',     // Full width of the viewport
            height: '100vh',    // Full height of the viewport
            maxWidth: '100vw',  // Prevent max width constraints
            maxHeight: '100vh', // Prevent max height constraints
            panelClass: 'full-screen-dialog' // Custom class for additional styling if needed
        });
    }


    sanitizeUrl(u: string): string {
        return (u || '')
            .replace(/^\/+/, '')
            .replace(/[?#&=]/g, '-')
            .replace(/[^a-zA-Z0-9_-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '')
            .toLowerCase();
    }

    protected _onDestroy = new Subject<void>();
}
